export const LOCALSTORAGE_KEYS = {
  authToken: 'auth._token.local',
};

export const COOKIE_KEYS = {
  authToken: 'auth._token.local',
  redirect: 'redirect'
};
